import { getEnvVar } from '@/utilities/get-env-var';

export const AG_GRID_LICENSE_KEY = getEnvVar('VITE_APP_AG_GRID_LICENSE_KEY') ?? '';
export const DATASTREAM = getEnvVar('VITE_APP_DATASTREAM_SERVER');
export const LOGIN_URI = `${getEnvVar('VITE_APP_ENTERPRISE_API_URI')}auth/login`;
export const LOGOUT_URI = `${getEnvVar('VITE_APP_ENTERPRISE_API_URI')}auth/logout`;
